---
title: 📡 DSARC Antenna Build Day — Lightweight NVIS for EmComm
date: 2026-03-21
endDate: 2026-03-21
location: Latah County Emergency Management Building, 2370 N Polk Extension, Moscow, ID
description: Join us for a hands-on build day as we construct a lightweight, packable NVIS antenna designed for emergency communications. Build, test, tune, and get on the air together! 📡
published: true
---

# 📡 DSARC Antenna Build Day — Lightweight NVIS for EmComm

Join the Do Something Amateur Radio Club for a hands-on build day as we work together to create a lightweight, packable **NVIS (Near Vertical Incidence Skywave) antenna** designed for emergency communications. Whether you're brand new or experienced, this is a great environment to learn by doing.

---

## 🗓️ Event Details

- **📅 Date:** Saturday, March 21, 2026
- **🕙 Time:** 10:00 AM – 2:00 PM (1000–1400)
- **📍 Location:** Latah County Emergency Management Building, 2370 N Polk Extension, Moscow, ID

---

## 🛠️ What We're Building

We'll be building a portable NVIS antenna ideal for:

- Local and regional HF communications
- Emergency communications (EmComm) scenarios
- Field deployments and portable operations

This antenna design is **lightweight**, **packable**, and **easy to deploy in the field** — perfect for go-kits, Field Day, and real-world response situations.

---

## 📍 Location

**Latah County Emergency Management Building**
2370 N Polk Extension, Moscow, ID 83843
<a href="https://maps.app.goo.gl/uqBRfTBmekTuyZqeA" target="_blank" rel="noopener noreferrer">Open in Google Maps</a>

---

<div class="mb-8">
  <iframe title="Map of Antenna Build Day location - 2370 N Polk Ext, Moscow, ID" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2733.397193161824!2d-116.9972685225216!3d46.75706684625334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x549f89eb009fd62f%3A0x8b1579fd92ae333c!2s2370%20N%20Polk%20Ext%2C%20Moscow%2C%20ID%2083843!5e0!3m2!1sen!2sus!4v1735864037788!5m2!1sen!2sus" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>

---

## 🎒 What to Expect

- 👷 Hands-on building and learning
- 📡 Discussion on NVIS theory and use cases
- 🧪 Testing and tuning the antenna after the build
- 🎙️ Getting on the air (conditions permitting!)

---

## 💡 Bring Your Gear

This is also a great time to bring radios, batteries, and portable setups, ask questions, and experiment with others. Come ready to learn!

---

## 🎒 What to Bring

- 📻 Your handheld or mobile radio (if you have one)
- 🔋 Batteries or portable power
- 📝 Notebook & pen
- 💧 Water and snacks

---

## 📻 Fun Fact & Pro Tip

**Fun Fact:** NVIS antennas are commonly used by military and emergency services because they allow reliable regional communication without relying on repeaters or infrastructure.

**Pro Tip:** When setting up an NVIS antenna, height matters — typically 0.1–0.25 wavelength above ground gives the best high-angle radiation for local coverage.

---

## 📬 Questions & Contact

Questions? Reach out on [Discord](https://discord.gg/432vsVAuwZ) or via our [contact page](/contact).

---

## 📰 More Details

Full announcement on our newsletter: [DSARC Antenna Build Day — This Saturday!](https://dsarc.substack.com/p/dsarc-antenna-build-day-this-saturday)
